var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsArticleOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4583 54.5417H44.9167V48.125H22.4583V54.5417ZM22.4583 41.7083H54.5417V35.2917H22.4583V41.7083ZM22.4583 28.875H54.5417V22.4583H22.4583V28.875ZM16.0417 67.375C14.2771 67.375 12.767 66.7472 11.5115 65.4917C10.256 64.2362 9.62714 62.7251 9.625 60.9583V16.0417C9.625 14.2771 10.2538 12.767 11.5115 11.5115C12.7692 10.256 14.2792 9.62714 16.0417 9.625H60.9583C62.7229 9.625 64.234 10.2538 65.4917 11.5115C66.7494 12.7692 67.3771 14.2792 67.375 16.0417V60.9583C67.375 62.7229 66.7472 64.234 65.4917 65.4917C64.2362 66.7494 62.7251 67.3771 60.9583 67.375H16.0417ZM16.0417 60.9583H60.9583V16.0417H16.0417V60.9583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsArticleOutline);
export default __webpack_public_path__ + "static/media/material-symbols_article-outline.82097123badf15dd5efeaabbd292570e.svg";
export { ForwardRef as ReactComponent };